import * as CoreFns from './CoreFns';


export function changeScreenHeight(thisScreen, isDraggingDetails, insetWidth, insetHeight){

  var screenHV = thisScreen.h.v;
  if (isDraggingDetails && isDraggingDetails.t === 'screenBottom'){
    var diff = isDraggingDetails.currentY - isDraggingDetails.clientY;
    screenHV += scaledDistance(diff, thisScreen.h.t, 'h', insetWidth, insetHeight);
    if (screenHV < 1){
      screenHV = 1;
    }
  }
  return screenHV; 
}

export function scaledDistance(distance, t, whichItemToChange, insetWidth, insetHeight){
  if (t === 'vh'){
    return distance * 100 / insetHeight;
  }else if (t === 'perc'){
    if (whichItemToChange === 'w' || whichItemToChange === 'l' || whichItemToChange === 'r'){
      return distance * 100 / insetWidth;
    }else if (whichItemToChange === 't' || whichItemToChange === 'h' || whichItemToChange === 'b'){
      return distance * 100 / insetHeight;
    }    
  }else if (t === 'vw'){
    return distance * 100 / insetWidth;
  }else if (t === 'em'){
    return distance / 10 ;
  }else if (t === 'px'){
    return distance ;
  }else if (t === 'int'){
    return distance;
  }
}

export function reverseScale(distance, t, whichItemToChange, insetWidth, insetHeight){
  if (t === 'vw' ){
    return distance * insetWidth/100;
  }else if (t === 'perc'){
    if (whichItemToChange === 'w' || whichItemToChange === 'l' || whichItemToChange === 'r'){
      return distance * insetWidth/100;
    }else if (whichItemToChange === 't' || whichItemToChange === 'h' || whichItemToChange === 'b'){
      return distance * insetHeight/100;
    }
  }else if (t === 'vh'){
    return distance * insetHeight/100;
  }else if (t === 'int'){
    return distance;
  }else if (t === 'px'){
    return distance;
  }else if (t === 'em'){
    return distance * 10;
  }
}

function originalWidth(considerationSet){
  return considerationSet.oWv - considerationSet.cLv - considerationSet.cRv;  
}

function originalHeight(considerationSet){
  return  considerationSet.oHv - considerationSet.cTv - considerationSet.cBv;
}

function expressedWidth(considerationSet, pos, insetWidth, insetHeight){
  var lr = pos.lr.v;
  if (lr === 0 || lr === 2){
    return reverseScale(considerationSet.wv, pos.w.t, 'w', insetWidth, insetHeight);
  }else if (lr === 1){
    var origL4 = reverseScale(considerationSet.lv, pos.l.t, 'l', insetWidth, insetHeight);
    var origR4 = reverseScale(considerationSet.rv, pos.r.t, 'r', insetWidth, insetHeight);
    return origR4 - origL4;
  }
}

export function findEmptyLoc(addPath, currentList, insetWidth, insetHeight){
  var residents = CoreFns.goDownPath(currentList, addPath);
  var residentKeys = Object.keys(residents);
  for (var l1 = 0; l1 < 3; l1++){
    for (var t1 = 0; t1 < 3; t1 ++){
      var candidateLocX = 5 + l1 * 30;
      var candidateLocY = 5 + t1 * 30;
      var actX = reverseScale(candidateLocX, 'vw', 'l', insetWidth, insetHeight);
      var actY = reverseScale(candidateLocY, 'vh', 't', insetWidth, insetHeight);

      var isOccupied = false;
      for (var z = 0; z < residentKeys.length; z++){
        var aKey = residentKeys[z];
        var thisResident = residents[aKey];
        var pos = thisResident.pos;
        var left; var top; var right; var height; var width; var bottom;

        if (pos.lr.v === 0 || pos.lr.v === 1){
          left = reverseScale(pos.l.v, pos.l.t, 'l', insetWidth, insetHeight);
        }

        if (pos.lr.v === 0 || pos.lr.v === 2){
          width = reverseScale(pos.w.v, pos.w.t, 'w', insetWidth, insetHeight);
        }

        if (pos.lr.v === 1 || pos.lr.v === 2){
          right = reverseScale(pos.r.v, pos.r.t, 'r', insetWidth, insetHeight);
        }

        if (pos.lr.v === 2){
          left = insetWidth - right - width;
        }

        if (pos.lr.v === 0){
          right = insetWidth - left - width;
        }

        var posRight = insetWidth - right;

        if (pos.ud.v === 0 || pos.ud.v === 1 || pos.ud.v === 3 || pos.ud.v === 5){
          top = reverseScale(pos.t.v, pos.t.t, 't', insetWidth, insetHeight);
        }

        if (pos.ud.v === 0 || pos.ud.v === 2){
          height = reverseScale(pos.h.v, pos.h.t, 'h', insetWidth, insetHeight);
        }

        if (pos.ud.v === 1 || pos.ud.v === 2 || pos.ud.v === 4 || pos.ud.v === 6){
          bottom = reverseScale(pos.b.v, pos.b.t, 'b', insetWidth, insetHeight);
        }

        if (pos.ud.v === 2){
          top = insetHeight - bottom - height;
        }

        if (pos.ud.v === 0){
          bottom = insetHeight - top - height;
        }

        if (pos.ud.v === 3 || pos.ud.v === 5){
          bottom = 0;
        }else if (pos.ud.v === 4 || pos.ud.v === 6){
          top = 0;
        }

        var posBottom = insetHeight - bottom;

        if (actX >= left && actX <= posRight && actY >= top && actY <= posBottom){
          isOccupied = true;
          break;
        }

      }

      if (!isOccupied){
        return {x:candidateLocX, y:candidateLocY};
      }


    }
  }

  return {x:5, y:5};

}

export function getConsiderationSet(pos, isPiece, isDraggingDetails, insetWidth, insetHeight, thisItem){

  var lr = pos.lr.v;
  var ud = pos.ud.v;

  var considerationSet = {};
  if (lr === 0 || lr === 1){
    considerationSet.lv = pos.l.v;
  }
  if (lr === 0 || lr === 2){
    considerationSet.wv = pos.w.v;
  }
  if (lr === 1 || lr === 2){
    considerationSet.rv = pos.r.v;
  }

  if (ud === 0 || ud === 1 || ud === 3 || ud === 5){
    considerationSet.tv = pos.t.v;
  }
  if (ud === 0 || ud === 2){
    considerationSet.hv = pos.h.v;
  }
  if (ud === 1 || ud === 2 || ud === 4 || ud === 6){
    considerationSet.bv = pos.b.v;
  }

  if (ud === 3 || ud === 4){
    var info = thisItem.info;
    considerationSet.oHv = info.oH;
    considerationSet.oWv = info.oW;
    considerationSet.cTv = info.cT.v;
    considerationSet.cLv = info.cL.v;
    considerationSet.cRv = info.cR.v;
    considerationSet.cBv = info.cB.v;      
    if (info.sca){
      considerationSet.sca = info.sca.v;
    }else{
      considerationSet.sca = 1;
      //so we also amend width, left, right based on results haha. shack. top too.
    }

  }

  if (isPiece){
    if (isDraggingDetails){

      var dragInst = isDraggingDetails.t;
      var y = (isDraggingDetails.currentY - isDraggingDetails.clientY);
      var x = (isDraggingDetails.currentX - isDraggingDetails.clientX);

      if (dragInst === 'leftMiddle' || dragInst === 'rightMiddle' || dragInst === 'topMiddle' || dragInst === 'bottomMiddle'){
          var startWidth1 = expressedWidth(considerationSet, pos, insetWidth, insetHeight);
          var origWidth = originalWidth(considerationSet);
          if (dragInst === 'leftMiddle' || dragInst === 'rightMiddle'){
            var mvtX = x * origWidth / startWidth1;
            if (dragInst === 'leftMiddle'){
              considerationSet.cLv += mvtX;
              if (considerationSet.cLv < 0){
                considerationSet.cLv = 0;
              }
              if (considerationSet.cLv + considerationSet.cRv > origWidth - 1){
                considerationSet.cLv = origWidth - 1 - considerationSet.cRv;
              }
              dragInst = 'leftTop';
            }else if (dragInst === 'rightMiddle'){
              considerationSet.cRv -= mvtX;
              if (considerationSet.cRv < 0){
                considerationSet.cRv = 0;
              }
              if (considerationSet.cLv + considerationSet.cRv > origWidth - 1){
                considerationSet.cRv = origWidth - 1 - considerationSet.cLv;
              }
              dragInst = 'rightTop';
            }
            y = 0;

          }else{
            var origHeight = originalHeight(considerationSet);
            var startHeight1 = startWidth1 * origHeight / origWidth;
            var mvtY = y * origHeight / startHeight1;
            if (dragInst === 'topMiddle'){
              considerationSet.cTv += mvtY;
              if (considerationSet.cTv < 0){
                considerationSet.cTv = 0;
              }
              if (considerationSet.cTv + considerationSet.cBv > origHeight - 1){
                considerationSet.cTv = origHeight - 1 - considerationSet.cBv;
              }
              dragInst = 'leftTop';
              x = 0;
            }else if (dragInst === 'bottomMiddle'){
              considerationSet.cBv -= mvtY;
              if (considerationSet.cBv < 0){
                considerationSet.cBv = 0;
              }
              if (considerationSet.cTv + considerationSet.cBv > origHeight - 1){
                considerationSet.cBv = origHeight - 1 - considerationSet.cTv;
              }
              dragInst = 'leftBottom';
              x = 0;
            }

          }
      }


      if (dragInst === 'all'){

        if (lr === 0 || lr === 1){
          considerationSet.lv += scaledDistance(x, pos.l.t, 'l', insetWidth, insetHeight);
        }

        if (lr === 2 || lr === 1){
          considerationSet.rv -= scaledDistance(x, pos.r.t, 'r', insetWidth, insetHeight);
        }

        if (ud === 0 || ud === 1 || ud === 3 || ud === 5){
          considerationSet.tv += scaledDistance(y, pos.t.t, 't', insetWidth, insetHeight);
        }

        if (ud === 1 || ud === 2 || ud === 4 || ud === 6){
          considerationSet.bv -= scaledDistance(y, pos.b.t, 'b', insetWidth, insetHeight);
        }
      }

      if (dragInst === 'leftTop' || dragInst === 'leftBottom'){

        if (lr === 0){
          var d11 = scaledDistance(x, pos.w.t, 'w', insetWidth, insetHeight);
          if (considerationSet.wv + d11 < 1){
            d11 = considerationSet.wv - 1;
          }
          considerationSet.wv -= d11;
          considerationSet.lv += scaledDistance(reverseScale(d11, pos.w.t, 'w', insetWidth, insetHeight), pos.l.t, 'l', insetWidth, insetHeight);
        }else if (lr === 1){
          considerationSet.lv += scaledDistance(x, pos.l.t, 'l', insetWidth, insetHeight);
          var actualLeft = reverseScale(considerationSet.lv, pos.l.t, 'l', insetWidth, insetHeight);
          var actualRight = reverseScale(considerationSet.rv, pos.r.t, 'r', insetWidth, insetHeight);
          if (actualLeft + actualRight > insetWidth - 1){
            considerationSet.lv = scaledDistance(insetWidth - actualRight - 1, pos.l.v, 'l', insetWidth, insetHeight);
          }
        }else if (lr === 2){
          considerationSet.wv -= scaledDistance(x, pos.w.t, 'w', insetWidth, insetHeight);
          if (considerationSet.wv < 1){
            considerationSet.wv = 1;
          }
        }

      }        

      if (dragInst === 'leftTop' || dragInst === 'rightTop'){

        if (ud === 0){
          var d10 = scaledDistance(y, pos.h.t, 'h', insetWidth, insetHeight);
          if (considerationSet.hv + d10 < 1){
            d10 = considerationSet.hv - 1;
          }
          considerationSet.hv -= d10;
          considerationSet.tv += scaledDistance(reverseScale(d10, pos.h.t, 'h', insetWidth, insetHeight), pos.t.t, 't', insetWidth, insetHeight);
        }else if (ud === 1){
          considerationSet.tv += scaledDistance(y, pos.t.t, 't', insetWidth, insetHeight);
          var actualTop = reverseScale(considerationSet.tv, pos.t.t, 't', insetWidth, insetHeight);
          var actualBottom = reverseScale(considerationSet.bv, pos.b.t, 'b', insetWidth, insetHeight);
          if (actualTop + actualBottom > insetHeight - 1){
            considerationSet.tv = scaledDistance(insetHeight - actualBottom - 1, pos.t.v, 't', insetWidth, insetHeight);
          }
        }else if (ud === 2){
          considerationSet.hv -= scaledDistance(y, pos.h.t, 'h', insetWidth, insetHeight);
          if (considerationSet.hv < 1){
            considerationSet.hv = 1;
          }
        }else if (ud === 3 || ud === 5){
          var d5 = scaledDistance(y, pos.t.t, 't', insetWidth, insetHeight);
          considerationSet.tv += d5;
        // }else if (ud === 4){
        //   var d6 = scaledDistance(y, pos.b.t, 'b', insetWidth, insetHeight);
        //   considerationSet.bv -= d6;
        }
      }



      if (dragInst === 'rightTop' || dragInst === 'rightBottom'){

        if (lr === 0){
          var d2 = scaledDistance(x, pos.w.t, 'w', insetWidth, insetHeight);
          if (considerationSet.wv + d2 < 1){
            d2 = - considerationSet.wv + 1;
          }           
          considerationSet.wv += d2;
        }else if (lr === 1){
          considerationSet.rv -= scaledDistance(x, pos.r.t, 'r', insetWidth, insetHeight);
          var actualLeft5 = reverseScale(considerationSet.lv, pos.l.t, 'l', insetWidth, insetHeight);
          var actualRight5 = reverseScale(considerationSet.rv, pos.r.t, 'r', insetWidth, insetHeight);
          if (actualLeft5 + actualRight5 > insetWidth - 1){
            considerationSet.rv = scaledDistance(insetWidth - actualLeft5 - 1, pos.r.v, 'r', insetWidth, insetHeight);
          }
        }else if (lr === 2){
          var d25 = scaledDistance(x, pos.w.t, 'w', insetWidth, insetHeight);
          if (considerationSet.wv + d25 < 1){
            d25 = - considerationSet.wv + 1;
          }           
          var distX2 = scaledDistance(reverseScale(d25, pos.w.t, 'w', insetWidth, insetHeight), pos.r.t, 'r', insetWidth, insetHeight);
          considerationSet.rv -= distX2;
          considerationSet.wv += d25;
        }


      }



      if (dragInst === 'leftBottom' || dragInst === 'rightBottom'){

        if (ud === 0){
          var d1 = scaledDistance(y, pos.h.t, 'h', insetWidth, insetHeight);
          if (considerationSet.hv  + d1 < 1){
            d1 = considerationSet.hv + 1;
          }           
          considerationSet.hv += d1;
        }else if (ud === 1){
          considerationSet.bv -= scaledDistance(y, pos.b.t, 'b', insetWidth, insetHeight);
          var actualTop5 = reverseScale(considerationSet.tv, pos.t.t, 't', insetWidth, insetHeight);
          var actualBottom5 = reverseScale(considerationSet.bv, pos.b.t, 'b', insetWidth, insetHeight);
          if (actualTop5 + actualBottom5 > insetHeight - 1){
            considerationSet.bv = scaledDistance(insetHeight - actualTop5 - 1, pos.b.v, 'b', insetWidth, insetHeight);
          }
        }else if (ud === 2){
          var d15 = scaledDistance(y, pos.h.t, 'h', insetWidth, insetHeight);
          if (considerationSet.hv  + d15 < 1){
            d15 = considerationSet.hv + 1;
          }           
          var dist = scaledDistance(reverseScale(d15, pos.h.t, 'h', insetWidth, insetHeight), pos.b.t, 'b', insetWidth, insetHeight);
          considerationSet.bv -= dist;
          considerationSet.hv += d15;
        }else if (ud === 4 || ud === 6){
          var d6 = scaledDistance(y, pos.b.t, 'b', insetWidth, insetHeight);
          considerationSet.bv -= d6;
        }
      }

    }
  }
  return considerationSet;
}
